import * as React from 'react';
import { Icon, IconProps } from '../Icon';

export const Calendar: React.FC<IconProps> = (props) => (
  <Icon viewBox="-1 0 12 13" {...props}>
    <path d="M8.651 1.5H10.5v3.081H0V1.5h1.968v.649c0 .595.486 1.079 1.086 1.079.599 0 1.086-.484 1.086-1.079V1.5h2.34v.649c0 .595.486 1.079 1.085 1.079.6 0 1.086-.484 1.086-1.079V1.5zM0 8.25h3V5.5H0zM3.75 8.25h3V5.5h-3zM7.5 8.25h3V5.5h-3zM0 11.75h3V9H0zM3.75 11.75h3V9h-3zM7.5 11.75h3V9h-3z" />
    <path d="M3.058 2.552a.557.557 0 01-.558-.558V.558a.558.558 0 011.115 0v1.436c0 .309-.25.558-.558.558M7.558 2.552A.557.557 0 017 1.994V.558a.558.558 0 011.115 0v1.436c0 .309-.25.558-.558.558" />
  </Icon>
);
